import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { baseUrl } from 'src/environments/environment';
import { showNotification } from '../helpers/show-toast';
import { LatestService } from '../_models/latestService.model';

@Injectable({
  providedIn: 'root',
})
export class LatestServicesService {
  servicesUrl = 'api/AdminServices';

  constructor(private http: HttpClient, public toastr: ToastrService) {}

  getAllServices(): Observable<any> {
    return this.http.get(`${this.servicesUrl}/GetAllAdminServices`);
  }

  addNewService(image, payload: LatestService): Observable<any> {
    const formData = new FormData();
    formData.append('pictureForm', image, image.name);
    formData.append('enName', payload.enName);
    formData.append('arName', payload.arName);
    formData.append('enShortDescription', payload.enShortDescription);
    formData.append('arShortDescription', payload.arShortDescription);
    // formData.append('startDate', payload.startDate.toDateString());
    // formData.append('endDate', payload.endDate.toDateString());
    formData.append('rank', payload.rank.toString());
    formData.append('routeId', payload.routeId.toString());
    formData.append('routeName', payload.routeName);

    formData.append('typeId', payload.typeId?.toString());
    formData.append('statusId', payload.statusId?.toString());

    return this.http.post(`${this.servicesUrl}/AddService`, formData);
  }

  deleteService(id: number): Observable<any> {
    return this.http.put(`${this.servicesUrl}/DeleteService`, {
      id
    });
  }

  getServiceById(id: number): Observable<any> {
    const params = {
      serviceId: id.toString()
    };
    return this.http.get(`${this.servicesUrl}/GetById`, {params});
  }

  updateService(image, payload: LatestService): Observable<any> {
    const formData = new FormData();

    if(image) {
      formData.append('pictureForm', image, image.name);
    } else {
      formData.append('pictureForm', '');
    }
    payload.id && formData.append('id', payload.id.toString());
    payload.enName && formData.append('enName', payload.enName);
    payload.arName && formData.append('arName', payload.arName);
    payload.enShortDescription && formData.append('enShortDescription', payload.enShortDescription);
    payload.arShortDescription && formData.append('arShortDescription', payload.arShortDescription);
    payload.rank && formData.append('rank', payload.rank.toString());
    payload.routeId && formData.append('routeId', payload.routeId.toString());
    payload.routeName && formData.append('routeName', payload.routeName);

    formData.append('typeId', payload.typeId?.toString());
    formData.append('statusId', payload.statusId?.toString());

    return this.http.put(`${this.servicesUrl}/UpdateService`, formData);
  }

  searchByName(serviceName) {
    return this.http.get(`${this.servicesUrl}/SearchByName/${serviceName}`);
  }
}
